(function($) {
    let isWait = true; 
    let targetScrollY = window.scrollY;
    let currentScrollY = window.scrollY;
    const lerpAmount = 0.08; 
    
    let innerTargetY = 0;
    let innerCurrentY = 0;
    let currentText = "";

    $(function () {
        const $loader = $("#loader");
        const $number = $(".loader-number");
        const $logo = $(".loader-title");
        const $header = $(".header-new");
        const $spMenu = $(".sp-menu");
        const $nav = $(".header-new-nav");
        
        const $fvLogo = $(".fv-logo");
        const $concept = $(".concept");
        const $productBox = $(".top-product-box");
        const $scrollArea = $(".top-product-area-wrap");
        const $targetText = $(".txtarea");
        
        const $blurredLayer = $("#blurred-layer");
        const $targetSection1 = $(".p2-concept1");
        const $parallaxWrapper = $(".p2-all-product, .all-product");
        const $parallaxImg = $(".p2-all-product-inner, .all-product-inner");
        const $inner = $(".p2-concept3-inner");
        const $boxes = $(".series-box");

        const isTopPage = $("body").hasClass("template-index") || window.location.pathname === "/";

        /* 1. カート更新システム */
        function updateCartCount() {
            fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json()).then(cart => {
                const els = document.querySelectorAll('#CartCount');
                els.forEach(el => { el.textContent = cart.item_count; });
            });
        }
        const originalFetch = window.fetch;
        window.fetch = function() {
            return originalFetch.apply(this, arguments).then(res => {
                if (res.url && res.url.includes('/cart/add') && res.ok) setTimeout(updateCartCount, 500);
                return res;
            });
        };

        /* 2. ハンバーガーメニュー */
        $spMenu.on("click", function() {
            $(this).toggleClass("active"); $nav.toggleClass("active");
            $("body").css("overflow", $nav.hasClass("active") ? "hidden" : "");
        });

        /* 3. ローディング演出 */
        function startLoader() {
            if (!$loader.length) {
                isWait = false;
                $("body").addClass("loaded").css("overflow", "visible");
                targetScrollY = window.scrollY;
                currentScrollY = targetScrollY;
                updateStackingHeight();
                return;
            }

            $("body").css("overflow", "hidden");
            let count = 100;
            const timer = setInterval(() => {
                count--;
                $number.text(count);
                if (count <= 0) {
                    clearInterval(timer);
                    $number.fadeOut(1000, function () {
                        setTimeout(() => {
                            $logo.addClass("is-visible");
                            setTimeout(() => {
                                $loader.addClass("fade-out");
                                setTimeout(() => {
                                    $("body").addClass("loaded").css("overflow", "visible");
                                    targetScrollY = window.scrollY;
                                    currentScrollY = targetScrollY;
                                    isWait = false;
                                    updateStackingHeight();
                                }, 1000);
                            }, 2000);
                        }, 500);
                    });
                }
            }, 15);
        }

        /* 4. アニメーション制御（積層判定を含む） */
        function handleAllAnimations(scrollTop) {
            const winH = window.innerHeight;

            if (isTopPage && $fvLogo.length && $concept.length) {
                const stopY = $concept.offset().top + 180;
                if (scrollTop + winH / 2 < stopY) {
                    $fvLogo.css({ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" });
                } else {
                    $fvLogo.css({ position: "absolute", top: stopY + "px", left: "50%", transform: "translate(-50%, -50%)" });
                }
            }

            if ($boxes.length) {
                const boxCount = $boxes.length;
                $boxes.each(function (index) {
                    const $current = $(this);
                    const $next = $boxes.eq(index + 1);
                    if (index + 1 === boxCount) {
                        $current.removeClass("is-sticky");
                        return;
                    }
                    if ($next.length) {
                        const nextTargetTop = parseInt($next.css("top")) || 0;
                        const nextCurrentOffset = $next.offset().top;
                        if (scrollTop >= nextCurrentOffset - nextTargetTop - 20) {
                            $current.addClass("is-sticky");
                        } else {
                            $current.removeClass("is-sticky");
                        }
                    }
                });
            }

            if ($targetSection1.length && $blurredLayer.length) {
                const sectionTop = $targetSection1.offset().top;
                const sectionH = $targetSection1.outerHeight();
                let blurOpacity = (scrollTop - sectionTop) / (sectionH * 0.7);
                $blurredLayer.css("opacity", Math.max(0, Math.min(blurOpacity, 1)));
            }

            if ($parallaxWrapper.length) {
                $parallaxWrapper.each(function(){
                    const offsetTop = $(this).offset().top;
                    if (scrollTop > offsetTop - winH && scrollTop < offsetTop + winH) {
                        $(this).find(".p2-all-product-inner, .all-product-inner").css("transform", `translateY(${(scrollTop - offsetTop) * 0.3}px)`);
                    }
                });
            }

            $(".fade-line, .p2-concept2-img, .p2-concept2-txtbox, .fade-in").each(function () {
                if (scrollTop > $(this).offset().top - winH * 0.85) $(this).addClass("is-visible");
            });

            if (isTopPage && $scrollArea.length) {
                const checkPoint = winH / 2;
                $(".top-product-area").each(function () {
                    const rect = this.getBoundingClientRect();
                    if (rect.top < checkPoint && rect.bottom > checkPoint) {
                        const newText = $(this).attr("data-text");
                        if (newText && currentText !== newText) {
                            currentText = newText;
                            $targetText.stop().fadeOut(200, function () { $(this).html(newText).fadeIn(300); });
                        }
                    }
                });
            }
        }

        /* 5. スクロールループ */
        const isPC = window.matchMedia("(min-width: 1025px)").matches;
        if (isPC) {
            window.addEventListener("wheel", (e) => {
                if (isWait) { e.preventDefault(); return; }
                if (isTopPage && $productBox.length && $scrollArea.length) {
                    const boxTop = $productBox.offset().top;
                    const stickyY = boxTop - (window.innerHeight / 2 - $productBox.outerHeight() / 2);
                    if (Math.abs(currentScrollY - stickyY) < 20) {
                        const maxInner = $scrollArea[0].scrollHeight - $scrollArea.innerHeight() - 5;
                        if ((e.deltaY > 0 && innerTargetY < maxInner) || (e.deltaY < 0 && innerTargetY > 0)) {
                            targetScrollY = stickyY;
                            innerTargetY = Math.max(0, Math.min(innerTargetY + e.deltaY, maxInner));
                            e.preventDefault(); return;
                        }
                    }
                }
                e.preventDefault();
                targetScrollY += e.deltaY;
                targetScrollY = Math.max(0, Math.min(targetScrollY, document.documentElement.scrollHeight - window.innerHeight));
            }, { passive: false });
        } else {
            // スマホ：横移動制限
            let touchStartX = 0;
            let touchStartY = 0;

            window.addEventListener('touchstart', (e) => {
                touchStartX = e.touches[0].pageX;
                touchStartY = e.touches[0].pageY;
            }, { passive: true });

            window.addEventListener('touchmove', (e) => {
                const x = e.touches[0].pageX;
                const y = e.touches[0].pageY;
                const moveX = Math.abs(x - touchStartX);
                const moveY = Math.abs(y - touchStartY);

                // 除外対象：Slickスライダーのみ
                // ※top-product-area-wrapは縦に動かすものなので、横揺れ防止のために「除外しない（制限をかける）」のが正解です
                const isSlick = e.target.closest('.slick-slider, .lineup-box, .bottom-slider-inner');

                // スライダー以外の場所で、横移動が縦移動より大きい場合にpreventDefaultを実行
                if (!isSlick && moveX > moveY) {
                    if (e.cancelable) e.preventDefault();
                }
            }, { passive: false });

            $(window).on("scroll", () => { if (!isWait) handleAllAnimations(window.scrollY); });
        }

        function update() {
            if (isPC && !isWait) {
                currentScrollY += (targetScrollY - currentScrollY) * lerpAmount;
                window.scrollTo(0, currentScrollY);
                innerCurrentY += (innerTargetY - innerCurrentY) * lerpAmount;
                if ($scrollArea.length) $scrollArea.scrollTop(innerCurrentY);
                handleAllAnimations(currentScrollY);
            }
            const st = isPC ? currentScrollY : window.scrollY;
            if (st > 50) $header.addClass("is-scrolled"); else $header.removeClass("is-scrolled");
            requestAnimationFrame(update);
        }

        /* 6. スライダー・アンカー・高さ計算 */
        if ($.fn.slick) {
            $(".lineup-box").not('.slick-initialized').slick({ infinite: false, arrows: false, slidesToShow: 3.5, swipeToSlide: true, responsive: [{ breakpoint: 1024, settings: { slidesToShow: 2.5 } }, { breakpoint: 767, settings: { slidesToShow: 1.5 } }] });
            $(".bottom-slider-inner").not('.slick-initialized').slick({ autoplay: true, autoplaySpeed: 0, speed: 8000, cssEase: "linear", slidesToShow: 4, arrows: false, pauseOnHover: false,responsive: [{ breakpoint: 1024, settings: { slidesToShow: 2.5 } }]});
            $(".fv-img").not('.slick-initialized').slick({ fade: true, speed: 2000, autoplay: true, autoplaySpeed: 4000, arrows: false, asNavFor: ".fv-txt" });
            $(".fv-txt").not('.slick-initialized').slick({ fade: true, speed: 2000, arrows: false, swipe: false });
        }

        $('.faq-anker a[href^="#"], .header-new-nav a[href^="#"]').on('click', function(e) {
            const href = $(this).attr('href'); if(href === "#") return; e.preventDefault();
            const $target = $(href);
            if ($target.length) {
                const targetPos = $target.offset().top - $header.outerHeight() - 20;
                if (isPC) targetScrollY = targetPos; else window.scrollTo({ top: targetPos, behavior: 'smooth' });
                $spMenu.removeClass("active"); $nav.removeClass("active"); $("body").css("overflow", "");
            }
        });

        $(".top-accordion-header, .accordion-header").on("click", function () { $(this).next().slideToggle(300); $(this).toggleClass("open"); });

        function updateStackingHeight() {
            if (!$boxes.length) return;
            let totalHeight = 0;
            const winH = $(window).height();

            $boxes.each(function (i) {
                totalHeight += $(this).outerHeight();
                if (i < $boxes.length - 1) {
                    totalHeight += parseInt($(this).css("margin-bottom")) || 0;
                }
            });
            $inner.css("height", totalHeight + winH + "px");
        }

        startLoader(); 
        requestAnimationFrame(update);
        $(window).on("resize load", () => { updateStackingHeight(); });
    });
})(jQuery);